import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "authentication-area" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "authentication-form" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-4 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Login", -1)),
            _createElementVNode("form", null, [
              _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"form-floating mb-4\"><input type=\"email\" class=\"form-control\" id=\"floatingInput2\" placeholder=\"Email\"><label for=\"floatingInput2\" class=\"floating\">Email</label></div><div class=\"form-floating mb-4\"><input type=\"password\" class=\"form-control\" id=\"floatingInput1\" placeholder=\"Password\"><label for=\"floatingInput1\" class=\"floating\">Password</label></div>", 2)),
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label position-relative tops-2",
                    for: "flexCheckDefault"
                  }, " Remember Me ")
                ], -1)),
                _createVNode(_component_RouterLink, {
                  to: "/forgot-password",
                  class: "forgot mt-2 mt-sm-0"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" FORGOT PASSWORD? ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"text-center\"><button type=\"submit\" class=\"btn px-275\"><span class=\"border-style\">Login Now</span></button></div><div class=\"py-4 text-center\">or</div><div class=\"text-center\"><button type=\"submit\" class=\"btn active px-275\"><span class=\"border-style\">Login With Phone Number</span></button></div>", 3))
            ])
          ])
        ])
      ])
    ])
  ]))
}